import { PreviewCard, WebVideo } from '@telus-uds/components-web'
import { BlogUrl } from 'src/blogBuilder/utils/blogUrl'
import BBImage from '../../Image'

import type {
  TypeArticleWithoutUnresolvableLinksResponse,
  TypeYoutubeVideoWithoutUnresolvableLinksResponse,
  TypeAuthorWithoutUnresolvableLinksResponse,
} from '@/bb-contentful-types'
import type { AssetFields, AssetFile } from 'contentful'

type FindHeaderValue = (category: string, publishDate: string) => string

const findHeaderValue: FindHeaderValue = (category, publishDate) => {
  if (category && publishDate) {
    return `${category} \u00B7 ${publishDate}`
  }
  return publishDate
}

type Props = {
  fullArticleUrl: string
  lang: 'en' | 'fr'
  category?: string
  article: TypeArticleWithoutUnresolvableLinksResponse['fields']
  fullBlogUrls: BlogUrl
}

const ArticleColumn = ({ article, fullArticleUrl, lang, category, fullBlogUrls }: Props) => {
  if (!article || !fullArticleUrl) {
    return null
  }

  const publishDate = new Date(article?.publishDate).toLocaleDateString(`${lang}-CA`, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })

  const header = findHeaderValue(category ? category : '', publishDate)
  let articleBaseUrl = fullArticleUrl
  const { intcmp } = article
  if (intcmp) {
    articleBaseUrl += `?intcmp=${intcmp}`
  }

  const url = `${fullBlogUrls?.hostName}${fullBlogUrls?.currentLang}/${articleBaseUrl}`
  const videoPreview = article?.previewVideo?.fields as TypeYoutubeVideoWithoutUnresolvableLinksResponse['fields']
  const thumbnailFields = videoPreview?.thumbnail?.fields as AssetFields
  const thumbnailFile = thumbnailFields?.file as AssetFile
  const imageFields = article?.image?.fields as AssetFields
  const imageFile = imageFields?.file as AssetFile
  const firstAuthor = article?.authors?.[0]?.fields as TypeAuthorWithoutUnresolvableLinksResponse['fields']
  const media =
    article?.previewVideo && videoPreview?.videoId
      ? {
          alt: article?.title,
          content: (
            <WebVideo
              videoId={videoPreview?.videoId}
              videoLength={videoPreview?.videoLength}
              aspectRatio="4:3"
              copy={lang}
              posterSrc={
                (videoPreview && videoPreview?.thumbnail && thumbnailFile?.url) ||
                (article.image && `https:${imageFile?.url}`)
              }
              // TODO - remove onStart once it is marked optional on the component
              // eslint-disable-next-line @typescript-eslint/no-empty-function
              onStart={() => {}}
            />
          ),
        }
      : {
          alt: article?.title,
          content: (
            <BBImage
              height={imageFile?.details?.image?.height}
              width={imageFile?.details?.image?.width}
              src={imageFile?.url}
              alt={imageFields?.description || imageFields?.title}
              removeWhiteSpace
              placeholder="blur"
              blurDataURL={imageFile?.url}
            />
          ),
        }

  return (
    <PreviewCard
      testID="article-column-bb"
      href={url}
      tag={header}
      title={article.title}
      footer={firstAuthor?.name}
      fullBleedContent={media}
    />
  )
}

export default ArticleColumn
